/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  createBaileysSession() {
    return axios.post(`${this.baseUrl()}/whatsapp/baileys_sessions`);
  }

  getBaileysSession(sessionKey) {
    return axios.get(
      `${this.baseUrl()}/whatsapp/baileys_sessions/${sessionKey}`
    );
  }

  createWahaInbox(name) {
    return axios.post(`${this.baseUrl()}/whatsapp/waha_sessions`, { name });
  }

  getWahaSession(inboxId, { signal } = {}) {
    return axios.get(`${this.baseUrl()}/whatsapp/waha_sessions/${inboxId}`, {
      signal,
    });
  }

  updateWahaSession(inboxId, action) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/waha_sessions/${inboxId}/${action}`
    );
  }
}

export default new WhatsappChannel();
